import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {initReactI18next} from "react-i18next";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // we init with resources
        resources: {
            en: {
                translations: {
                    $: "RM",
                    switchLang: "भाषा बदलो",
                    dontHaveAnAccountRegisterNow: "Don’t have an account? Register now.",
                    required: "Required",
                    invalidEmail: "Invalid email",
                    invalidPassword: "Invalid password",
                    kg: "kg",
                    help: "Help",
                    collectTheRightPlastic: "Collect the right plastic",
                    whatYouNeed: "What you need to know",
                    plastXPayments: "PlastX payments",
                    contactUs: "Contact Us",
                    generalEnquiries: "General enquiries",
                    reportAProblem: "Report a problem",
                    legals: "Legals",
                    privacyPolicy: "Privacy Policy",
                    terms: "Terms",
                    viewProfile: "View Profile",
                    inProgress: "In Progress",
                    fulfilled: "Fulfilled",
                    toCollect: "to collect",
                    myPlastxProfile: "My PlastX Profile",
                    editAccount: "Edit account",
                    name: "Name",
                    firstName: "First Name",
                    lastName: "Last Name",
                    location: "Location",
                    phoneNumber: "Phone number",
                    yourAuthorizedPlastxId: "Your authorised PlastX Collector ID",
                    yes: "Yes",
                    no: "No",
                    username: "Username",
                    password: "Password",
                    login: "Login",
                    register: "Register",
                    forgotPassword: "Forgot Password?",
                    jobs: "Jobs",
                    logout: "Logout",
                    myJobs: "My Jobs",
                    browseNew: "Browse New",
                    jobDetail: "Job Detail",
                    price: "Price",
                    dropOffDate: "Drop-off date",
                    dropOffLocation: "Drop-off location",
                    whatToCollect: "What to Collect",
                    plasticType: "Plastic Type",
                    recyclingNumber: "Recycling Number",
                    colour: "Colour",
                    cleaned: "Cleaned",
                    minimumCollectionAmount: "Minimum Collection Amount",
                    minimumCollectionAccepted: "Minimum Collection Accepted (kg)",
                    minimumCollection: "Minimum Collection",
                    selectAmountToCollect: "Select amount to Collect",
                    backToBrowse: "Back to Browse",
                    howMuchWillYouCollect: "How Much Will You Collect?",
                    confirm: "Confirm",
                    backToJob: "Back to Job",
                    toGo: "To go",
                    collected: "Collected",
                    youWillEarn: "You will earn",
                    logADelivery: "Log a Delivery",
                    changeAmountToCollect: "Change amount to collect",
                    logYourDelivery: "Log your delivery",
                    deliverToHub: "Please take your plastic to one of the hubs listed below",
                    collectorDetail: "Collector Detail",
                    authorizedPlastXNumber: "Authorized PlastX Number",
                    collectorId: "Collector ID",
                    jobId: "Job ID",
                    done: "Done",
                    logReceiving: "Log a record of receiving recovered plastic from a collector",
                    collector: "Collector",
                    quantityKg: "Quantity (kg)",
                    ensureQualityCheck: "Please ensure that the collector details are correct and that the plastic has undergone a quality check",
                    logCollection: "Log Collection",
                    siteOperator: "Site Operator",
                    orders: "Orders",
                    collection: "Collection",
                    siteSettings: "Site Settings",
                    collectors: "Collectors",
                    recordACollection: "Record a collection",
                    success: "Success!",
                    logANewCollection: "Log a new Collection",
                    "Clear PET Plastic Bottles - with Lid / with Label": "साफ पेट प्लास्टिक बोतल – ढक्कन सहित/ लेबल सहित",
                    // These can potentially be a non-ascii - so include both the ascii and unicode one
                    "Clear PET Plastic Bottle – NO Lid / with Label": "Clear PET Plastic Bottle – NO Lid / with Label",
                    "Clear PET Plastic Bottle – NO Lid / NO Label": "Clear PET Plastic Bottle – NO Lid / NO Label",
                    "Clear PET Plastic Bottle - NO Lid / with Label": "Clear PET Plastic Bottle - NO Lid / with Label",
                    "Clear PET Plastic Bottle - NO Lid / NO Label": "Clear PET Plastic Bottle - NO Lid / NO Label",
                    otherDetails: "Other Details",
                    extraRequirements: "Extra Requirements",
                    notes: "Notes",
                    "Must NOT contain food or other things": "Must NOT contain food or other things",
                    "Must NOT smell": "Must NOT smell",
                    "Bottles must be whole / NOT broken / Bent is OK": "Bottles must be whole / NOT broken / Bent is OK",
                    "Bottles MUST be Clear / Can you see clearly  through it?": "Bottles MUST be Clear / Can you see clearly  through it?",
                    "SLIGHT blue colouration is OK / NO other colours": "SLIGHT blue colouration is OK / NO other colours",
                    "If you squeeze a bottle and it creases with a white line then it is the WRONG plastic type and will NOT be accepted": "If you squeeze a bottle and it creases with a white line then it is the WRONG plastic type and will NOT be accepted",
                    flag:"🇬🇧",
                    language:"English",
                    qualityControlCheck:"Quality Control Check",
                    readyToDeliver: "Ready to Deliver!",
                    collectorToComplete:"Collector to complete",
                    verifyQualityControl: "Verify Type and Location",
                    areYouDeliveringTheRightPlastic:"Are you delivering the right plastic?",
                    areYouDeliveringToTheRightHub:"Are you delivering to the right hub?",
                    okToLog:"OK to Log",
                    hubIn:"HUB in",
                    collectorName:"Collector Name",
                    collectorIdCheck:"Collector ID Check",
                    kgs:"KGs",
                    inQualityConfirmed:"In Quality Confirmed",
                    okToPay:"Ok to Pay",
                    hubOut:"HUB Out",
                    qualityChecked:"Quality Checked",
                    collectionBagged:"Collection Bagged",
                    securityTagAttached:"Security Tag Attached",
                    securityTagScanned:"Security Tag Scanned",
                    logPickup:"Log Pickup",
                    processor:"Processor",
                    accept:"Accept",
                    reject:"Reject",
                    reasonForRejection:"Reason for rejection",
                    email: "Email",
                    birthDate: "Date of Birth",
                    deliveryLocations: "Delivery locations",
                    country: "Country",
                    committedToCollect: "Committed to Collect",
                    jobsInProgress: "Jobs in Progress",
                    yourCommitment: "Your Commitment",
                    earnWithPlastx: "Earn more with PLASTX - the smart way to collect & sell Scrap Plastic in Asia!",
                    currentCommitment: "Your current commitment:",
                    allRightsReserved: "All Rights Reserved.",
                    uploadImage: "Upload image",
                    iAccept: "I accept the ",
                    termsAndConditions: "Terms and Conditions",
                    declareOver18: "I declare that I am over 18 years old",
                    jobNum: "Job #",
                    collectionSites: "Collection Sites:"
                }
            },
            hi: {
                translations: {
                    $: "RM",
                    switchLang: "เปลี่ยนภาษา",
                    dontHaveAnAccountRegisterNow: "अकाउंट नहीं है? रजिस्टर करें",
                    required: "जरूरी",
                    invalidEmail: "गलत ईमेल",
                    invalidPassword: "गलत पास वर्ड",
                    kg: "kg",
                    help: "सहायता",
                    collectTheRightPlastic: "सही प्लास्टिक इकठ्ठा करें",
                    whatYouNeed: "आपको क्या करना है",
                    plastXPayments: "प्लास्टएक्स भुगतान",
                    contactUs: "संपर्क करें",
                    generalEnquiries: "सामान्य पूछ ताछ",
                    reportAProblem: "समस्या बतायें",
                    legals: "कानूनी बातें",
                    privacyPolicy: "गोपनीयता नीति",
                    terms: "शर्तें",
                    viewProfile: "प्रोफाइल देखें",
                    inProgress: "जारी है",
                    fulfilled: "पूरा हुआ",
                    toCollect: "इकठ्ठा करना है",
                    myPlastxProfile: "मेरा प्लास्ट एक्स प्रोफाइल",
                    editAccount: "अकाउंट में बदलाव करें",
                    name: "नाम",
                    firstName: "पहला नाम",
                    lastName: "अंतिम नाम",
                    location: "स्थान",
                    phoneNumber: "फ़ोन नंबर",
                    yourAuthorizedPlastxId: "आपका अधिकृत प्लास्ट एक्स नंबर",
                    yes: "हाँ",
                    no: "नहीं",
                    username: "उपयोग कर्ता का नाम",
                    password: "पास वर्ड",
                    login: "लॉग इन",
                    register: "रजिस्टर करें",
                    forgotPassword: "पास वर्ड भूल गए?",
                    jobs: "काम",
                    logout: "लॉग आउट",
                    myJobs: "मेरा काम",
                    browseNew: "नया खोजें",
                    jobDetail: "काम का विवरण",
                    price: "मूल्य",
                    dropOffDate: "देने का दिन",
                    dropOffLocation: "देने का स्थान",
                    whatToCollect: "क्या इकठ्ठा करना है?",
                    plasticType: "प्लास्टिक का प्रकार",
                    recyclingNumber: "नंबर",
                    colour: "रंग",
                    cleaned: "साफ है",
                    minimumCollectionAmount: "न्यूनतम मात्रा का मूल्य",
                    minimumCollection: "न्यूनतम मात्रा",
                    selectAmountToCollect: "ली जाने वाली कीमत को चुने",
                    backToBrowse: "पीछे जाकर खोजे",
                    howMuchWillYouCollect: "आप कितना इकट्ठा करेंगे?",
                    confirm: "पुष्टि करें",
                    backToJob: "वापस काम  वाले मेनू पर जाये",
                    toGo: "जाने के लिए",
                    collected: "इकठ्ठा किये",
                    youWillEarn: "आपने कमाया",
                    logADelivery: "दिए गये सामान की जानकारी",
                    changeAmountToCollect: "पैसों की मात्रा में बदलाव",
                    logYourDelivery: "दिए गये सामान को दर्ज करें",
                    collectorDetail: "संग्रह कर्ता का विवरण",
                    authorizedPlastXNumber: "प्रमाणित प्लास्टएक्स नंबर",
                    collectorId: "संग्रह कर्ता की पहचान",
                    jobId: "काम का नंबर",
                    done: "पूरा हुआ",
                    logReceiving: "संग्रह कर्ता से लिए समान को दर्ज करें",
                    collector: "संग्रह कर्ता",
                    quantityKg: "मात्रा (किलो ग्राम में)",
                    ensureQualityCheck: "कृपया सुनिश्चित करें कि संग्रह कर्ता का विवरण ठीक है और उसके द्वारा दिए गए सामान के गुणवत्ता की जाँच की गयी है",
                    logCollection: "इकठ्ठा किये गए सामान की जानकारी",
                    siteOperator: "संचालक",
                    orders: "मांग",
                    collection: "इकठ्ठा हुआ",
                    siteSettings: "!!!!!!!!!!MISSING TEXT!!!!!!!!!!",
                    collectors: "संग्रह कर्ता",
                    recordACollection: "इकठ्ठा किये गये सामान का विवरण",
                    success: "सफल",
                    logANewCollection: "नए समान की जानकारी दें",
                    "Clear PET Plastic Bottles - with Lid / with Label": "साफ पेट प्लास्टिक बोतल – ढक्कन सहित/ लेबल सहित",
                    // These can potentially be a non-ascii - so include both the ascii and unicode one
                    "Clear PET Plastic Bottle – NO Lid / with Label": "साफ पेट प्लास्टिक बोतल – बगैर ढक्कन/ लेबल सहित",
                    "Clear PET Plastic Bottle – NO Lid / NO Label": "साफ पेट प्लास्टिक बोतल – बगैर ढक्कन/ बगैर लेबल",
                    "Clear PET Plastic Bottle - NO Lid / with Label": "साफ पेट प्लास्टिक बोतल – बगैर ढक्कन/ लेबल सहित",
                    "Clear PET Plastic Bottle - NO Lid / NO Label": "साफ पेट प्लास्टिक बोतल – बगैर ढक्कन/ बगैर लेबल",
                    otherDetails: "अन्य विवरण",
                    "Must NOT contain food or other things": "बोतल में कोई चीज न हो",
                    "Must NOT smell": "बोतल में कोई महक न हो",
                    "Bottles must be whole / NOT broken / Bent is OK": "बोतल पूरी हो/ टूटी न हो, मुड़ी न हो",
                    "Bottles MUST be Clear / Can you see clearly  through it?": "बोतल पूरी तरह साफ हो/ उससे आर-पार साफ देखा जा सके",
                    "SLIGHT blue colouration is OK / NO other colours": "किसी प्रकार का रंग न हो (हल्का नीला हो सकता है)",
                    "If you squeeze a bottle and it creases with a white line then it is the WRONG plastic type and will NOT be accepted": "यदि आप बोतल को दबाते है और इससे बोतल पर सफ़ेद लाइन बन जाती है तो ऐसा बोतल स्वीकार नहीं किया जायेगा",
                    flag:"🇮🇳",
                    language:"हिंदी",
                    qualityControlCheck:"Quality Control Check",
                    collectorToComplete:"Collector to complete",
                    areYouDeliveringTheRightPlastic:"Are you delivering the right plastic?",
                    areYouDeliveringToTheRightHub:"Are you delivering to the right hub?",
                    okToLog:"OK to Log",
                    hubIn:"HUB in",
                    collectorName:"Collector Name",
                    collectorIdCheck:"Collector ID Check",
                    kgs:"KGs",
                    inQualityConfirmed:"In Quality Confirmed",
                    okToPay:"Ok to Pay",
                    hubOut:"HUB Out",
                    qualityChecked:"Quality Checked",
                    collectionBagged:"Collection Bagged",
                    securityTagAttached:"Security Tag Attached",
                    securityTagScanned:"Security Tag Scanned",
                    logPickup:"Log Pickup",
                    processor:"Processor",
                    accept:"Accept",
                    reject:"Reject",
                    reasonForRejection:"Reason for rejection",
                }
            },
            th: {
                translations: {
                    $: "RM",
                    switchLang: "Tukar bahasa",
                    dontHaveAnAccountRegisterNow: "ไม่มีบัญชีผู้ใช้? สมัครบัญชีผู้ใช้",
                    required: "Required",
                    invalidEmail: "อีเมลไม่ถูกต้อง",
                    invalidPassword: "รหัสผ่านไม่ถูกต้อง",
                    kg: "กิโลกรัม",
                    help: "ความช่วยเหลือ",
                    collectTheRightPlastic: "รวบรวมขยะพลาสติกที่เหมาะสม",
                    whatYouNeed: "สิ่งที่คุณต้องการ",
                    plastXPayments: "प्การชำระเงินของ PlastX",
                    contactUs: "ติดต่อเรา",
                    generalEnquiries: "สอบถามข้อมูลทั่วไป",
                    reportAProblem: "รายงานปัญหา",
                    legals: "กฏหมาย",
                    privacyPolicy: "นโยบายคุ้มครองข้อมูลส่วนบุคคล",
                    terms: "ข้อกำหนด",
                    viewProfile: "ดูโพรไฟล์",
                    inProgress: "กำลังดำเนินการ",
                    fulfilled: "สำเร็จลุล่วง",
                    toCollect: "ที่เก็บรวบรวม",
                    myPlastxProfile: "โพรไฟล์ PlastX ของฉัน",
                    editAccount: "แก้ไขบัญชี",
                    name: "ชื่อ",
                    firstName: "ชื่อ",
                    lastName: "นามสกุล",
                    location: "ตำแหน่งที่ตั้ง",
                    phoneNumber: "หมายเลขโทรศัพท์",
                    yourAuthorizedPlastxId: "หมายเลขอนุญาต PlastX ของคุณ",
                    yes: "ใช่",
                    no: "ไม่",
                    username: "ชื่อผู้ใช้",
                    password: "รหัสผ่าน",
                    login: "เข้าระบบ",
                    register: "Register",
                    forgotPassword: "ลืมรหัสผ่าน?",
                    jobs: "कामภารกิจ",
                    logout: "ออกจากระบบ",
                    myJobs: "ภารกิจของฉัน",
                    browseNew: "ค้นหาใหม่",
                    jobDetail: "รายละเอียดภารกิจ",
                    price: "ราคา",
                    dropOffDate: "วันส่งมอบ",
                    dropOffLocation: "สถานที่ส่งมอบ",
                    whatToCollect: "สิ่งที่เก็บรวบรวม",
                    plasticType: "ประเภทของพลาสติก",
                    recyclingNumber: "หมายเลขรีไซเคิล",
                    colour: "สี",
                    cleaned: "สะอาดแล้ว",
                    minimumCollectionAmount: "จำนวนที่เก็บรวบรวมขั้นต่ำ",
                    minimumCollection: "เก็บรวบรวมขั้นต่ำ",
                    selectAmountToCollect: "เลือกจำนวนที่รวบรวม",
                    backToBrowse: "กลับไปที่ ค้นหา",
                    howMuchWillYouCollect: "คุณจะรวบรวมเท่าไร",
                    confirm: "ยืนยัน",
                    backToJob: "กลับไปที่ ภารกิจ",
                    toGo: "ยอดคงเหลือ",
                    collected: "รวบรวมแล้ว",
                    youWillEarn: "คุณจะได้รับ",
                    logADelivery: "บันทึกการจัดส่ง",
                    changeAmountToCollect: "เปลี่ยนจำนวนที่รวบรวม",
                    logYourDelivery: "บันทึกการจัดส่งของคุณ",
                    collectorDetail: "รายละเอียดผู้เก็บรวบรวมขยะ",
                    authorizedPlastXNumber: "प्หมายเลขอนุญาต PlastX",
                    collectorId: "เลขประจำตัวผู้เก็บรวบรวมขยะ",
                    jobId: "เลขที่ภารกิจ",
                    done: "เสร็จสิ้น",
                    logReceiving: "บันทึกข้อมูลการรับขยะพลาสติกที่เก็บมาได้จากผู้เก็บรวบรวมขยะ",
                    collector: "ผู้เก็บรวบรวมขยะ",
                    quantityKg: "จำนวน (กิโลกรัม)",
                    ensureQualityCheck: "โปรดตรวจสอบให้แน่ใจว่ารายละเอียดของผู้เก็บรวบรวมขยะถูกต้องและพลาสติกได้ผ่านการตรวจสอบคุณภาพแล้ว",
                    logCollection: "บันทึกการเก็บรวบรวม",
                    siteOperator: "เจ้าหน้าที่ศูนย์รับขยะพลาสติก",
                    orders: "สั่งซื้อสินค้า",
                    collection: "การเก็บรวบรวม",
                    siteSettings: "การตั้งค่าเว็บไซต์",
                    collectors: "ผู้เก็บรวบรวมขยะ",
                    recordACollection: "บันทึกข้อมูลการเก็บรวบรวม",
                    success: "สำเร็จ!",
                    logANewCollection: "บันทึกการเก็บรวบรวมใหม่",
                    "Clear PET Plastic Bottles - with Lid / with Label": "ขวดพลาสติก PET ใส - มีฝาปิด / มีฉลาก",
                    // These can potentially be a non-ascii - so include both the ascii and unicode one
                    "Clear PET Plastic Bottle – NO Lid / with Label": "ขวดพลาสติก PET ใส - ไม่มีฝาปิด / มีฉลาก",
                    "Clear PET Plastic Bottle – NO Lid / NO Label": "ขวดพลาสติก PET ใส - ไม่มีฝาปิด / ไม่มีฉลาก",
                    "Clear PET Plastic Bottle - NO Lid / with Label": "ขวดพลาสติก PET ใส - ไม่มีฝาปิด / มีฉลาก",
                    "Clear PET Plastic Bottle - NO Lid / NO Label": "ขวดพลาสติก PET ใส - ไม่มีฝาปิด / ไม่มีฉลาก",
                    otherDetails: "รายละเอียดอื่นๆ",
                    "Must NOT contain food or other things": "ต้องไม่มีอาหารหรือสิ่งอื่นๆ บรรจุอยู่",
                    "Must NOT smell": "ต้องไม่มีกลิ่น",
                    "Bottles must be whole / NOT broken / Bent is OK": "ขวดต้องสมบูรณ์ / ไม่แตก / อาจงอได้",
                    "Bottles MUST be Clear / Can you see clearly  through it?": "ขวดต้องใส / โปร่งแสง คุณมองทะลุผ่านได้ชัดไหม?",
                    "SLIGHT blue colouration is OK / NO other colours": "อาจมีสีฟ้าอ่อน ๆ ได้ / ห้ามมีสีอื่น",
                    "If you squeeze a bottle and it creases with a white line then it is the WRONG plastic type and will NOT be accepted": "หากคุณบีบขวดแล้วเกิดรอยเป็นเส้นสีขาว แสดงว่าเป็นพลาสติกผิดประเภทและจะไม่รับพลาสติกประเภทนี้",
                    flag: "🇹🇭",
                    language:"ไทย",
                    qualityControlCheck:"Quality Control Check",
                    collectorToComplete:"สำหรับผู้เก็บรวบรวมขยะตรวจให้เรียบร้อย",
                    areYouDeliveringTheRightPlastic:"คุณจัดส่งพลาสติกที่ถูกต้องเหมาะสมหรือไม่",
                    areYouDeliveringToTheRightHub:"คุณจัดส่งไปถูกศูนย์หรือไม่",
                    okToLog:"ตกลงให้บันทึกข้อมูลได้",
                    hubIn:"เข้าสู่ศูนย์",
                    collectorName:"ชื่อผู้เก็บรวบรวมขยะ",
                    collectorIdCheck:"ตรวจสอบเลขประจำตัวผู้เก็บรวบรวมขยะ",
                    kgs:"กิโลกรัม",
                    inQualityConfirmed:"ยืนยันคุณภาพแล้ว",
                    okToPay:"ตกลงให้จ่ายเงินได้",
                    hubOut:"ออกจากศูนย์",
                    qualityChecked:"ตรวจสอบคุณภาพแล้ว",
                    collectionBagged:"บรรจุใส่ถุงแล้ว",
                    securityTagAttached:"ติดแถบป้ายเพื่อความปลอดภัยแล้ว",
                    securityTagScanned:"อ่านข้อมูลแถบป้ายเพื่อความปลอดภัยแล้ว",
                    logPickup:"บันทึกการรับ",
                    processor:"เครื่องประมวลผล",
                    accept:"ยอมรับ",
                    reject:"ปฏิเสธ",
                    reasonForRejection:"เหตุผลในการปฏิเสธ",
                }
            },
            my : {
                translations: {
                    $: "RM",
                    switchLang: "Change Language",
                    dontHaveAnAccountRegisterNow: "Tiada akaun? Daftar sekarang.",
                    required: "Diperlukan",
                    invalidEmail: "Invalid email",
                    invalidPassword: "Invalid password",
                    kg: "kg",
                    help: "Bantuan",
                    collectTheRightPlastic: "Kumpul plastik yang betul",
                    whatYouNeed: "Apa yang anda perlukan",
                    plastXPayments: "Pembayaran PlastX",
                    contactUs: "HUBUNGI KAMI",
                    generalEnquiries: "Pertanyaan am",
                    reportAProblem: "Laporkan masalah",
                    legals: "UNDANG-UNDANG",
                    privacyPolicy: "Dasar Privasi",
                    terms: "Syarat",
                    viewProfile: "Lihat profil",
                    inProgress: "Sedang Berlangsung",
                    fulfilled: "Dipenuhi",
                    toCollect: "Untuk mengumpul",
                    myPlastxProfile: "Profil PlastX saya",
                    editAccount: "Edit akaun",
                    name: "Nama",
                    firstName: "Nama pertama",
                    lastName: "Nama terakhir",
                    location: "Lokasi",
                    phoneNumber: "Nombor telefon",
                    yourAuthorizedPlastxId: "Nombor PlastX Sah Anda",
                    yes: "Ya",
                    no: "Tidak",
                    username: "Nama pengguna",
                    password: "Kata laluan",
                    login: "Log masuk",
                    register: "Daftar",
                    forgotPassword: "Lupa kata laluan?",
                    jobs: "Pekerjaan",
                    logout: "Log keluar",
                    myJobs: "Pekerjaan Saya",
                    browseNew: "Layari Baharu",
                    jobDetail: "Butiran Kerja",
                    price: "harga",
                    dropOffDate: "Tarikh turun",
                    dropOffLocation: "Lokasi penghantaran",
                    whatToCollect: "Apa yang Perlu Dikumpul",
                    plasticType: "Jenis Plastik",
                    recyclingNumber: "Nombor Kitar Semula",
                    colour: "Warna",
                    cleaned: "Dibersihkan",
                    minimumCollectionAmount: "Jumlah Kutipan Minimum",
                    minimumCollection: "Koleksi Minimum",
                    selectAmountToCollect: "Pilih jumlah untuk dikutip",
                    backToBrowse: "Kembali ke Semak imbas",
                    howMuchWillYouCollect: "Berapa banyak yang akan anda kumpulkan?",
                    confirm: "sahkan",
                    backToJob: "Kembali ke Ayub",
                    toGo: "Untuk pergi",
                    collected: "Dikumpul",
                    youWillEarn: "Anda akan mendapat",
                    logADelivery: "Log Penghantaran",
                    changeAmountToCollect: "Tukar jumlah untuk dikutip",
                    logYourDelivery: "Log penghantaran anda",
                    collectorDetail: "Butiran Pengumpul",
                    authorizedPlastXNumber: "Nombor PlastX Dibenarkan",
                    collectorId: "ID pengumpul",
                    jobId: "ID kerja",
                    done: "Selesa",
                    logReceiving: "Log rekod penerimaan plastik yang diperoleh daripada pengumpul",
                    collector: "Pengumpul",
                    quantityKg: "Kuantiti (kg)",
                    ensureQualityCheck: "Sila pastikan butiran pengumpul adalah betul, dan plastik telah menjalani pemeriksaan kualiti",
                    logCollection: "Koleksi Log",
                    siteOperator: "Operator Tapak",
                    orders: "Pesanan",
                    collection: "Koleksi",
                    siteSettings: "Tetapan Tapak",
                    collectors: "Pengumpul",
                    recordACollection: "Rakam koleksi",
                    success: "Berjaya!",
                    logANewCollection: "Log Koleksi baharu",
                    "Clear PET Plastic Bottles - with Lid / with Label": "Botol Plastik PET Jelas - dengan Penutup / dengan Label",
                    // These can potentially be a non-ascii - so include both the ascii and unicode one
                    "Clear PET Plastic Bottle – NO Lid / with Label": "Clear PET Plastic Bottle – NO Lid / with Label",
                    "Clear PET Plastic Bottle – NO Lid / NO Label": "Botol Plastik PET Jelas – TIADA Penutup / TIADA Label",
                    "Clear PET Plastic Bottle - NO Lid / with Label": "Botol Plastik PET Jelas – TIADA Penutup / dengan Label",
                    "Clear PET Plastic Bottle - NO Lid / NO Label": "Botol Plastik PET Jelas – TIADA Penutup / TIADA Label",
                    otherDetails: "Butiran yang lain",
                    "Must NOT contain food or other things": "TIDAK boleh mengandungi makanan atau benda lain",
                    "Must NOT smell": "Mesti TIDAK mempunyai bau",
                    "Bottles must be whole / NOT broken / Bent is OK": "Botol mestilah utuh / TIDAK pecah / Bengkok OK",
                    "Bottles MUST be Clear / Can you see clearly  through it?": "Botol MESTI Jelas / Lutsinar Bolehkah anda melihat dengan jelas melaluinya?",
                    "SLIGHT blue colouration is OK / NO other colours": "Warna biru SEDIKIT OK / TIADA warna lain",
                    "If you squeeze a bottle and it creases with a white line then it is the WRONG plastic type and will NOT be accepted": "Jika anda memerah botol dan ia berkedut dengan garis putih maka ia adalah jenis plastik yang SALAH dan TIDAK akan diterima.",
                    flag:"🇲🇾",
                    language:"Malay",
                    qualityControlCheck:"Semakan Kawalan Kualiti",
                    collectorToComplete:"Pengumpul untuk Menyiapkan",
                    areYouDeliveringTheRightPlastic:"Adakah anda menghantar plastik yang betul?",
                    areYouDeliveringToTheRightHub:"Adakah anda menghantar ke hab yang betul?",
                    okToLog:"OK untuk LOG",
                    hubIn:"HUB in",
                    collectorName:"Nama Pengumpul",
                    collectorIdCheck:"Collector ID Check",
                    kgs:"KGs",
                    inQualityConfirmed:"In Quality Confirmed",
                    okToPay:"Ok to Pay",
                    hubOut:"HUB Out",
                    qualityChecked:"Quality Checked",
                    collectionBagged:"Collection Bagged",
                    securityTagAttached:"Security Tag Attached",
                    securityTagScanned:"Security Tag Scanned",
                    logPickup:"Log Pickup",
                    processor:"Processor",
                    accept:"Accept",
                    reject:"Reject",
                    reasonForRejection:"Reason for rejection",
                    email: "E-mel",
                    birthDate: "Tarikh lahir",
                    jobsInProgress: "Pekerjaan dalam Proses",
                    committedToCollect: "Komited untuk mengumpul",
                    yourCommitment: "Komitmen Anda",
                    notes:"Nota",
                    readyToDeliver: "Sedia untuk dihantar!",
                    collectionSites: "Tapak Pengumpulan",
                    allRightsReserved: "Hak Cipta Terpelihara",
                    delivertoHub: "Sila bawa plastik anda ke salah satu HUBS yang disenaraikan di bawah"

                }
            },
            cn : {
                translations: {
                    $: "RM",
                    switchLang: "Change Language",
                    dontHaveAnAccountRegisterNow: "没有帐户？现在注册",
                    required: "必需的",
                    invalidEmail: "Invalid email",
                    invalidPassword: "Invalid password",
                    kg: "kg",
                    help: "帮助",
                    collectTheRightPlastic: "收集正确的塑料",
                    whatYouNeed: "你需要知道什么",
                    plastXPayments: "PlastX 支付",
                    contactUs: "联系我们",
                    generalEnquiries: "一般查询",
                    reportAProblem: "报告一个问题",
                    legals: "合法的",
                    privacyPolicy: "隐私政策",
                    terms: "条款",
                    viewProfile: "查看我的资料",
                    inProgress: "Sedang Berlangsung",
                    fulfilled: "Dipenuhi",
                    toCollect: "去收集",
                    myPlastxProfile: "Profil PlastX saya",
                    editAccount: "Edit akaun",
                    name: "Nama",
                    firstName: "名",
                    lastName: "姓",
                    location: "Lokasi",
                    phoneNumber: "电话号码",
                    yourAuthorizedPlastxId: "Nombor PlastX Sah Anda",
                    yes: "是的",
                    no: "不",
                    username: "用户名",
                    password: "密码",
                    login: "登录",
                    register: "注册",
                    forgotPassword: "忘记密码？",
                    jobs: "职位",
                    logout: "登出",
                    myJobs: "我的工作",
                    browseNew: "浏览新职位",
                    jobDetail: "职位详情",
                    price: "价格",
                    dropOffDate: "归期",
                    dropOffLocation: "下车地点",
                    whatToCollect: "收集什么",
                    plasticType: "塑料型",
                    recyclingNumber: "回收编号",
                    colour: "颜色",
                    cleaned: "干净的？",
                    minimumCollectionAmount: "可接受的最小收集量",
                    minimumCollectionAccepted: "可接受的最小收集量（千克）",
                    minimumCollection: "接受的最低金额",
                    selectAmountToCollect: "选择您要收集的塑料量",
                    backToBrowse: "返回浏览",
                    howMuchWillYouCollect: "你会收集多少钱？",
                    confirm: "确认",
                    backToJob: "返回“我的作品”",
                    toGo: "Untuk pergi",
                    collected: "我收集的塑料量",
                    youWillEarn: "你会赚",
                    logADelivery: "Log Penghantaran",
                    changeAmountToCollect: "改变你收集的塑料量",
                    logYourDelivery: "Log penghantaran anda",
                    collectorDetail: "Butiran Pengumpul",
                    authorizedPlastXNumber: "授权 PlastX 编号",
                    collectorId: "ID pengumpul",
                    jobId: "工作编号",
                    done: "Selesa",
                    logReceiving: "Log rekod penerimaan plastik yang diperoleh daripada pengumpul",
                    collector: "集电极",
                    quantityKg: "Kuantiti (kg)",
                    ensureQualityCheck: "Sila pastikan butiran pengumpul adalah betul, dan plastik telah menjalani pemeriksaan kualiti",
                    logCollection: "录一个集合",
                    siteOperator: "枢纽运营商",
                    orders: "命令",
                    collection: "收集",
                    siteSettings: "Tetapan Tapak",
                    collectors: "集电极",
                    recordACollection: "记录一个集合",
                    success: "成功！",
                    logANewCollection: "Log Koleksi baharu",
                    "Clear PET Plastic Bottles - with Lid / with Label": "透明 PET 塑料瓶 - 带盖/带标签",
                    // These can potentially be a non-ascii - so include both the ascii and unicode one
                    "Clear PET Plastic Bottle – NO Lid / with Label": "Clear PET Plastic Bottle – NO Lid / with Label",
                    "Clear PET Plastic Bottle – NO Lid / NO Label": "Botol Plastik PET Jelas – TIADA Penutup / TIADA Label",
                    "Clear PET Plastic Bottle - NO Lid / with Label": "Botol Plastik PET Jelas – TIADA Penutup / dengan Label",
                    "Clear PET Plastic Bottle - NO Lid / NO Label": "Botol Plastik PET Jelas – TIADA Penutup / TIADA Label",
                    otherDetails: "其他详情",
                    "Must NOT contain food or other things": "不得包含食物或其他物品",
                    "Must NOT smell": "Mesti TIDAK mempunyai bau",
                    "Bottles must be whole / NOT broken / Bent is OK": "Botol mestilah utuh / TIDAK pecah / Bengkok OK",
                    "Bottles MUST be Clear / Can you see clearly  through it?": "瓶子必须是透明的。你能看清楚吗？",
                    "SLIGHT blue colouration is OK / NO other colours": "Warna biru SEDIKIT OK / TIADA warna lain",
                    "If you squeeze a bottle and it creases with a white line then it is the WRONG plastic type and will NOT be accepted": "Jika anda memerah botol dan ia berkedut dengan garis putih maka ia adalah jenis plastik yang SALAH dan TIDAK akan diterima.",
                    flag:"🇨🇳",
                    language:"简体中文",
                    qualityControlCheck:"Semakan Kawalan Kualiti",
                    collectorToComplete:"Pengumpul untuk Menyiapkan",
                    areYouDeliveringTheRightPlastic:"您提供的塑料是否正确？",
                    areYouDeliveringToTheRightHub:"你要去正确的枢纽吗？",
                    okToLog:"好的！",
                    hubIn:"HUB in",
                    collectorName:"Nama Pengumpul",
                    collectorIdCheck:"Collector ID Check",
                    kgs:"公斤",
                    inQualityConfirmed:"In Quality Confirmed",
                    okToPay:"Ok to Pay",
                    hubOut:"HUB Out",
                    qualityChecked:"Quality Checked",
                    collectionBagged:"Collection Bagged",
                    securityTagAttached:"Security Tag Attached",
                    securityTagScanned:"Security Tag Scanned",
                    logPickup:"Log Pickup",
                    processor:"Processor",
                    accept:"Accept",
                    reject:"Reject",
                    reasonForRejection:"Reason for rejection",
                    email: "电子邮件地址",
                    birthDate: "出生日期",
                    earnWithPlastx: "通过 PlastX 赚取更多——在亚洲收集和销售废塑料的明智方式",
                    allRightsReserved: "版权所有",
                    country: "居住国家",
                    uploadImage: "上传图片",
                    iAccept: "我接受",
                    termsAndConditions: "条款及条件",
                    declareOver18: "我声明我已年满 18 岁",
                    jobsInProgress: "我已经在做的工作",
                    committedToCollect: "我承诺收集的塑料量",
                    otherDetails: "其他详情",
                    notes: "笔记",
                    currentCommitment:"您当前的承诺",
                    readyToDeliver: "准备好交付了吗？",
                    verifyQualityControl: "确认塑料类型和交货地点",
                    jobNum: "工作编号",
                    collectionSites: "收集点："
                }
            }
        },
        fallbackLng: "en",
        debug: false,

        // have a common namespace used around the full app
        ns: ["translations"],
        defaultNS: "translations",

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
